import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PAYROLL_SALARY,
  DELETE_PAYROLL_SALARY,
  UPDATE_PAYROLL_SALARY,
  ADD_NEW_PAYROLL_SALARY,
} from "./actionType";

import {
  getPayrollSalarySuccess,
  getPayrollSalaryFail,
  deletePayrollSalarySuccess,
  deletePayrollSalaryFail,
  updatePayrollSalarySuccess,
  updatePayrollSalaryFail,
  addPayrollSalarySuccess,
  addPayrollSalaryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePayrollSalaryApi,
  getPayrollSalaryApi,
  updatePayrollSalaryApi,
  deletePayrollSalaryApi,
  addNewPayrollSalaryApi
} from "../../helpers/backend_helper";

function* getPayrollSalary({ payload: payrollSalary }) {
  try {
    const response = yield call(getPayrollSalaryApi, payrollSalary);
    yield put(getPayrollSalarySuccess(GET_PAYROLL_SALARY, response.data));
  } catch (error) {
    yield put(getPayrollSalaryFail(GET_PAYROLL_SALARY, error));
  }
}

function* onUpdatePayrollSalary({ payload: payrollSalary }) {
  try {
    if (payrollSalary.setApprove) {
      const response = yield call(approvePayrollSalaryApi, payrollSalary);
      yield put(updatePayrollSalarySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePayrollSalaryApi, payrollSalary);
      yield put(updatePayrollSalarySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePayrollSalaryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePayrollSalary({ payload: payrollSalary }) {
  try {
    const response = yield call(deletePayrollSalaryApi, payrollSalary);
    yield put(deletePayrollSalarySuccess({ payrollSalary, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePayrollSalaryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPayrollSalary({ payload: payrollSalary }) {
  try {
    const response = yield call(addNewPayrollSalaryApi, payrollSalary);
    yield put(addPayrollSalarySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPayrollSalaryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPayrollSalary() {
  yield takeEvery(GET_PAYROLL_SALARY, getPayrollSalary);
}

export function* watchUpdatePayrollSalary() {
  yield takeEvery(UPDATE_PAYROLL_SALARY, onUpdatePayrollSalary);
}

export function* watchDeletePayrollSalary() {
  yield takeEvery(DELETE_PAYROLL_SALARY, onDeletePayrollSalary);
}

export function* watchAddNewPayrollSalary() {
  yield takeEvery(ADD_NEW_PAYROLL_SALARY, onAddNewPayrollSalary);
}

function* payrollSalarySaga() {
  yield all([
    fork(watchGetPayrollSalary),
    fork(watchDeletePayrollSalary),
    fork(watchUpdatePayrollSalary),
    fork(watchAddNewPayrollSalary)
  ]);
}

export default payrollSalarySaga;
